import { useQuery, UseQueryOptions } from 'react-query';

import { ZAPIER_APP_BASE_URL } from 'app/common/constants';

import useNotify from './useNotify';

const QUERY_KEY_PREFIX = 'query-collaborators';
const getQueryKey = (integrationId: string) =>
  `${QUERY_KEY_PREFIX}-${integrationId}`;

function useQueryCollaborators(
  integrationId: string,
  options?: UseQueryOptions<{ objects: any }>
) {
  const notify = useNotify();

  const queryKey = getQueryKey(integrationId);
  const url = `${ZAPIER_APP_BASE_URL}/api/platform/cli/apps/${integrationId}/limited_collaborators`;

  const { data, error, ...rest } = useQuery(
    queryKey,
    () => fetch(url, { credentials: 'include' }).then(res => res.json()),
    options
  );

  if (error) {
    notify.failure('Failed to fetch collaborators.');
  }

  const collaborators = data?.objects ?? [];

  return { ...rest, collaborators, error, queryKey };
}

export default useQueryCollaborators;
export { getQueryKey, QUERY_KEY_PREFIX };
